module.exports = __webpack_public_path__ + "static/media/bud.acc850b6.jpg";